import { CallNotificationModal } from './CallNotificationModal';

interface OfficerAssignedDialogProps {
  isOpen: boolean;
  eventId?: string;
  natureOfCall?: string;
  callLocation?: string;
  onViewCall: () => void;
  onDismiss: () => void;
}

export function OfficerAssignedDialog({
  isOpen,
  eventId,
  natureOfCall,
  callLocation,
  onViewCall,
  onDismiss,
}: OfficerAssignedDialogProps) {
  return (
    <CallNotificationModal
      open={isOpen}
      title="Assigned to Call"
      eventId={eventId}
      natureOfCall={natureOfCall}
      location={callLocation}
      variant="assigned"
      onViewCall={onViewCall}
      onDismiss={onDismiss}
    />
  );
}

(window as any).OfficerAssignedDialogReact = OfficerAssignedDialog;
